import { motion } from "framer-motion";
import { FaTools } from "react-icons/fa";
import F1 from "../assets/s11.png";

const NuestrosServicios = () => {
  const services = [
    { name: "Renta de maquinaria" },
    { name: "Mantenimiento de instalaciones" },
    { name: "Material de construcción" },
    { name: "Mantenimiento de equipo médico y preventivo de obra civil hospitalaria" },
    { name: "Mantenimiento electromecánico" },
  ];

  return (
    <div className="pt-12 px-4 md:px-16">
      <motion.h2
        className="text-red-700 text-5xl text-center font-semibold mb-12"
        initial={{ y: -50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        Nuestros servicios
      </motion.h2>
      <div className="flex flex-col md:flex-row items-center gap-8">
        <motion.div
          className="flex-1"
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <img src={F1} alt="Nuestros servicios" className="w-full rounded-xl shadow-lg" />
        </motion.div>
        <div className="flex-1 flex flex-col gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center text-center"
              initial={{ y: 50, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="bg-red-700 rounded-full p-4 mb-2">
                <FaTools className="text-amber-400 w-6 h-6" />
              </div>
              <h3 className="text-red-700 font-semibold text-lg">{service.name}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NuestrosServicios;
